import { FaInstagram, FaLinkedinIn, FaFacebookF, FaPhone, FaEnvelope, FaGlobe } from "react-icons/fa";
import bgImage1 from "../../assets/bg-background.png";
import logo from "../../assets/KW-Bodrum.png";
import { useState } from "react";

const Card = ({ data }) => {
  const [downloading, setDownloading] = useState(false);

  // const handleVCardDownload = () => {
  //   if (!data || !data.slug) return;

  //   const slug = data.slug;
  //   const downloadUrl = `https://giseya.com/project/kwdemo/vcard.php?slug=${slug}`;

  //   const a = document.createElement('a');
  //   a.href = downloadUrl;
  //   a.download = `${slug}.vcf`;
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // };

  const handleVCardDownload = () => {
    setDownloading(true);

    const slug = data.slug; // veya props.slug
    // const downloadUrl = `http://localhost/kw-kartvizit/panel/vcard.php?slug=${slug}`;
    const downloadUrl = `https://app.kwbodrum.com.tr/panel/vcard.php?slug=${slug}`;

    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = `${slug}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Birkaç saniye sonra spinnerı kaldır (bazı tarayıcılarda indirme olayı tam yakalanamıyor)
    setTimeout(() => setDownloading(false), 3000);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: data.full_name || "Keller Williams Bodrum",
        text: `${data.full_name} dijital profiline göz atın!`,
        url: window.location.href,
      })
        .then(() => console.log('Profil başarıyla paylaşıldı!'))
        .catch((error) => console.error('Paylaşım iptal edildi veya hata oluştu:', error));
    } else {
      alert("Tarayıcınız bu paylaşım özelliğini desteklemiyor.");
    }
  };


  return (
    <div style={{
      backgroundImage: `url(${bgImage1})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      borderRadius: "20px",
      padding: "20px 20px",
      maxWidth: "350px",
      margin: "auto",
      marginTop: "0px",
      fontFamily: "sans-serif",
      color: "#fff",
      textAlign: "center",
      boxShadow: "0 16px 20px rgba(0,0,0,0.25)"
    }}>
      {/* Profil Fotoğrafı */}
      
        <img
          src={data.foto_url ? data.foto_url : "/profile-picture.png"}
          alt={data.full_name}
          style={{
            width: 170,
            height: 170,
            borderRadius: "50%",
            objectFit: "cover",
            margin: "10px auto 10px",
            display: "block"
          }}
        />
      {/* İsim ve Ünvan */}
      <h2 style={{ marginBottom: 6, fontSize: 20, fontWeight: 700, letterSpacing: 1 }}>
        {data.full_name}
      </h2>
      <p style={{ margin: 0, fontWeight: 600, marginBottom: 10, fontSize: 14 }}>{data.team && (data.team) + " |"}  {data.unvan}</p>
      {data.bolge && (<p style={{ margin: 0, marginBottom: 10, fontSize: 14 }}><b>Uzmanlık Bölgesi: </b>{data.bolge}</p>)}
      {data.bio && (
        <div style={{
          background: "rgba(255,255,255,0.07)",
          padding: "12px",
          borderRadius: "10px",
          fontSize: "13px",
          color: "#ddd",
          fontStyle: "italic",
          marginBottom: 10
        }}>
          {data.bio}
        </div>
      )}
      <img src={logo} alt="KW Bodrum" style={{ width: 160, margin: "8px auto 16px" }} />

      {/* İletişim Bilgileri */}
      <div style={{ textAlign: "left", marginBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <FaPhone color="#c6001a" />
          <span>{data.phone}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
          <FaEnvelope color="#c6001a" />
          <span>{data.email}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <FaGlobe color="#c6001a" />
          <span>{data.web}</span>
        </div>
      </div>

      {/* Sosyal Medya İkonları */}
      <div style={{ display: "flex", justifyContent: "center", gap: 14, marginBottom: 20 }}>
        {data.instagram && (
          <a href={data.instagram} target="_blank" rel="noreferrer"
            style={{ background: "#fff", fontSize: 20, borderRadius: "50%", padding: 10, paddingBottom: 5, color: "#c6001a" }}>
            <FaInstagram />
          </a>
        )}
        {data.linkedin && (
          <a href={data.linkedin} target="_blank" rel="noreferrer"
            style={{ background: "#fff", fontSize: 20, borderRadius: "50%", padding: 10, paddingBottom: 5, color: "#c6001a" }}>
            <FaLinkedinIn />
          </a>
        )}
        {data.facebook && (
          <a href={data.facebook} target="_blank" rel="noreferrer"
            style={{ background: "#fff", fontSize: 20, borderRadius: "50%", padding: 10, paddingBottom: 5, color: "#c6001a" }}>
            <FaFacebookF />
          </a>
        )}
        {data.sahibinden && (
          <a
            href={data.sahibinden}
            target="_blank"
            rel="noopener noreferrer"
            className="text-yellow-500 hover:text-yellow-600 transition duration-200"
            title="Sahibinden Profili"
          >
            {/* SVG'yi buraya koy */}
            <img src="/icons/sahibinden.png" alt="Sahibinden"
              style={{ background: "#fff", width: 30, borderRadius: "50%", padding: 5, color: "#c6001a" }} />
          </a>
        )}
      </div>

      {/* Butonlar */}
      <div style={{ display: "flex", gap: 10 }}>
        <button onClick={handleVCardDownload} style={{
          flex: 1,
          background: "#c6001a",
          color: "#fff",
          border: "none",
          padding: "10px",
          borderRadius: "8px",
          fontWeight: 600,
          cursor: "pointer"
        }}>
          {downloading ? (
            <>Rehbere Ekleniyor...</>
          ) : (
            <>
              Rehbere Kaydet
            </>
          )}
        </button>
        <button
          onClick={handleShare}
          style={{
            flex: 1,
            background: "#c6001a",
            color: "#fff",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            fontWeight: 600,
            cursor: "pointer"
          }}>
          Profili Paylaş
        </button>
      </div>
    </div>
  );
};

export default Card;
